import { LoyaltyMembership } from '@mews-commander/data-access';
import { getLoyaltyProgram } from '@mews-commander/legacy-entities/src/ducks/loyaltyPrograms';
import { getLoyaltyTier } from '@mews-commander/legacy-entities/src/ducks/loyaltyTiers';
import { useCommanderSelector } from '@mews-commander/utils';
import { UnicodeEntity } from '@mews/enums';

interface LoyaltyMembershipLabelProps {
    loyaltyMembership: LoyaltyMembership;
}

export const LoyaltyMembershipLabel = ({ loyaltyMembership }: LoyaltyMembershipLabelProps) => {
    const loyaltyProgram = useCommanderSelector((s) =>
        loyaltyMembership?.loyaltyProgramId ? getLoyaltyProgram(s, { id: loyaltyMembership.loyaltyProgramId }) : null
    );
    const loyaltyTier = useCommanderSelector((s) =>
        loyaltyMembership?.loyaltyTierId ? getLoyaltyTier(s, { id: loyaltyMembership.loyaltyTierId }) : null
    );

    return (
        <>
            {loyaltyProgram?.name}
            {loyaltyTier && (
                <>
                    {UnicodeEntity.Space}
                    {loyaltyTier.name}
                </>
            )}
        </>
    );
};
